export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--K.f1a76a35.png";